// NavigationButtons component

import React from "react";
import { connect } from "react-redux";

import { Button } from "ui-components";
import { updateStep } from "@pretravel/components/Sidebar/action";

import { NavigationWrapper } from "@common/styled/navigation";

class NavigationButtons extends React.Component {
  doStep = direction => {
    let newStepMeta = Object.assign({}, this.props.stepsMeta);
    let currentStepIdx = this.props.stepsMeta.activeSubStep;

    // Determine which direction we're moving
    switch (direction) {
      case "next":
        currentStepIdx += 1;
        break;
      case "prev":
        currentStepIdx > 0 ? (currentStepIdx -= 1) : (currentStepIdx = 0);
        break;
      default:
        break;
    }
    newStepMeta.activeSubStep = currentStepIdx;
    this.props.updateStep(newStepMeta);
  };

  getButtons = () => {
    const totalSubSteps = this.props.subsections.length;
    const currentSubStep = this.props.stepsMeta.activeSubStep;
    const isFirstSubStep = currentSubStep === 0;
    const isLastSubStep = currentSubStep === totalSubSteps - 1 ? true : false;

    const buttons = [];

    // Prompt the user to add suggested/specific tips
    buttons.push(
      <Button
        key="risk_indicator"
        medium
        disabled={!this.props.isRiskIndicated}
        onClick={this.props.showAppendixDialog}
      >
        Add Actions
      </Button>
    );

    if (!isLastSubStep) {
      buttons.push(
        <Button key="0" medium onClick={() => this.doStep("next")}>
          Next
        </Button>
      );
    }

    if (!isFirstSubStep) {
      buttons.unshift(
        <Button key="1" secondary medium onClick={() => this.doStep("prev")}>
          Previous
        </Button>
      );

      if (isLastSubStep) {
        buttons.push(
          <Button
            key="3"
            primary
            medium
            onClick={this.props.showCompletionDialog}
          >
            Complete
          </Button>
        );
      }
    }

    return buttons;
  };

  render() {
    return (
      <NavigationWrapper>
        {this.getButtons()}
      </NavigationWrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    updateStep: args => dispatch(updateStep(args))
  };
}

function mapStateToProps(store) {
  return {
    stepsMeta: store.preTravel.sidebar.stepsMeta,
    subsections: store.preTravel.app.subsections
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationButtons);



// WEBPACK FOOTER //
// ./src/pretravel/components/Content/NavigationButton/navigationButton.jsx